import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "./ExportToExcel";
import Pagination from "./Pagination";
import SearchBar from "./SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Dynamic_FilterForm from "./Dynamic_FilterForm";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";

const CRDynamic_PR_table = ({
  data,
  selectedResource,
  selectAllChecked,
  columns,
  isSrNoRequired,
  ReadOnlyValues,

  isApiStatus,
  isRequiredStatus,
  defaultColumns,
  handleBtn,
  // itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleIconClick,
  hanldeLinkColumn,
  handleModalColumn,
  handleColumnSelect,
  hanldeImageClick,
  icons,
  isActionRequired,
  isCheckBoxRequired,
  handleReset,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  showIcon6,
  showIcon7,
  showIcon8,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleIcon6,
  handleIcon7,
  handleIcon8,
  handleGetData,
  handleAddNew,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {

  const [visibleColumns, setVisibleColumns] = useState(
    Object.keys(columns).reduce((acc, key) => {
      acc[key] = columns[key].visible; // Set initial visibility based on the 'visible' key
      return acc;
    }, {})
  );

  useEffect(() => {
    setVisibleColumns(
      Object.keys(columns).reduce((acc, key) => {
        acc[key] = columns[key].visible;
        return acc;
      }, {})
    );
  }, [columns]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [columnName]: !prevState[columnName], // Toggle visibility
    }));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  const sortedData = useMemo(() => {
  if (!Array.isArray(data) || !sortConfig) return data || [];
  
  const { key, direction } = sortConfig;

  const parseValue = (val) => {
    if (val === null || val === undefined || String(val).trim() === "") {
      return { type: "null", value: null }; // treat as lowest
    }

    const strVal = String(val).trim();

    // 🔹 Experience (e.g., "2 yr 1 m")
    const expMatch = strVal.match(/(\d+)\s*yr[s]?\s*(\d+)?\s*m?/i);
    if (expMatch) {
      const years = parseInt(expMatch[1] || 0, 10);
      const months = parseInt(expMatch[2] || 0, 10);
      return { type: "exp", value: years * 12 + months };
    }

    // 🔹 Date
    if (moment(strVal, ["DD-MM-YYYY", "DD-MMM-YYYY", "YYYY-MM-DD"], true).isValid()) {
      return {
        type: "date",
        value: moment(strVal, ["DD-MM-YYYY", "DD-MMM-YYYY", "YYYY-MM-DD"]).toDate(),
      };
    }

    // 🔹 Currency/Salary values (e.g., "100", "120", "1000", "2000")
    // Remove any commas, currency symbols, and whitespace then check if it's a number
    const cleanStr = strVal.replace(/[$,₹€£\s]/g, '').trim();
    const numVal = parseFloat(cleanStr);
    if (!isNaN(numVal) && cleanStr !== "") {
      return { type: "number", value: numVal };
    }

    // 🔹 EMP ID (like NSS-1222)
    const empMatch = strVal.match(/^([A-Za-z\-]+)(\d+)$/);
    if (empMatch) {
      return { type: "empid", prefix: empMatch[1], number: Number(empMatch[2]) };
    }

    // 🔹 Default string
    return { type: "string", value: strVal.toLowerCase() };
  };

  return [...data].sort((a, b) => {
    const parsedA = parseValue(a[key]);
    const parsedB = parseValue(b[key]);

    // Handle null/undefined/empty
    if (parsedA.type === "null" && parsedB.type === "null") return 0;
    if (parsedA.type === "null") return 1; // null goes last
    if (parsedB.type === "null") return -1;

    let comparison = 0;

    // Handle same type comparisons
    if (parsedA.type === parsedB.type) {
      switch (parsedA.type) {
        case "date":
          comparison = parsedA.value - parsedB.value;
          break;
        case "number":
        case "exp":
          comparison = parsedA.value - parsedB.value;
          break;
        case "empid":
          if (parsedA.prefix === parsedB.prefix) {
            comparison = parsedA.number - parsedB.number;
          } else {
            comparison = parsedA.prefix.localeCompare(parsedB.prefix);
          }
          break;
        case "string":
          comparison = parsedA.value.localeCompare(parsedB.value);
          break;
        default:
          comparison = 0;
      }
    } else {
      // Handle different types - you might want to refine this logic
      comparison = parsedA.type.localeCompare(parsedB.type);
    }

    return direction === "ascending" ? comparison : -comparison;
  });
}, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
  Object.values(item).some((value) => {
    let strValue = String(value);

    // Detect date-like string (DD-MM-YYYY)
    if (/^\d{2}-\d{2}-\d{4}$/.test(strValue)) {
      strValue = moment(strValue, "DD-MM-YYYY").format("DD-MMM-YYYY"); 
      // "06-08-2012" -> "06-Aug-2012"
    }

    // Also format search term if it looks like a date
    let search = searchTerm;
    if (/^\d{2}-[A-Za-z]{3}-\d{4}$/.test(searchTerm)) {
      search = moment(searchTerm, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    }

    return strValue.toLowerCase().includes(search.toLowerCase());
  })
);

  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

  //old code for date fromat
  // const formatDate = (date) => {
  //   if (!date) return ""; // Handle null or undefined dates

  //   // Check if the date is already in DD-MM-YYYY format
  //   const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  //   if (dateRegex.test(date)) {
  //     return date;
  //   }

  //   return moment(date).format("DD-MMM-YYYY");
  // };

  //new updateed code for date fromat
  const formatDate = (date) => {
    if (!date) return null; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
        "DD-MMM-YYYY",
        "DD-MM-YY",
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : date;
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const [dropDownValue, setDropdownValue] = useState({});
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);

  // Calculate total pages based on the current `selectedRecordsPerPage`
  const totalPages = Math.ceil(filteredData.length / selectedRecordsPerPage);

  // Data to display for the current page
  const currentPageData = filteredData.slice(
    (currentPage - 1) * selectedRecordsPerPage,
    currentPage * selectedRecordsPerPage
  );
  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  return (
    <div className="container-fluid">
      <div className="container-fluid p-0">
        {/* First row - search and filter */}
        <div className="row g-2 d-flex d-md-none" style={{ marginBottom:"-30px" }}>
          <div className="col-10">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="col-2 dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>
              <div>
                <Dynamic_FilterForm
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleReset={handleReset}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>

        {/* Second row - action buttons (mobile only) */}
        <div className="row g-2 mb-2 d-flex d-md-none justify-content-end">
          <div className="col-auto">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
            >
              <div>
                <ExportToExcel
                  data={currentData.map((item) => {
                    const visibleItem = {};
                    Object.keys(columns)
                      .filter((columnName) => visibleColumns[columnName])
                      .forEach((columnName) => {
                        const isDateColumn =
                          /\b(date|on Bench|Date|From|To)\b/i.test(
                            columns[columnName].text
                          );
                        visibleItem[columns[columnName].text] = isDateColumn
                          ? formatDate(item[columnName])
                          : item[columnName];
                      });
                    return visibleItem;
                  })}
                  filename={`${ExcelName}.csv`}
                />
              </div>
            </OverlayTrigger>
          </div>
          <div className="col-auto">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
            >
              <div className="btn-group" style={{ zIndex: 100 }}>
                <button
                  type="button"
                  className="dropdown-toggle skill-button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  id="excel-btn"
                >
                  <i className="bi bi-list"></i>
                </button>
                <ul className="dropdown-menu p-2">
                  <div
                    className="row"
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                  >
                    <Form.Group>
                      {Object.keys(columns).map((columnName) => (
                        <Form.Check
                          key={columnName}
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          type="checkbox"
                          id={`checkbox-${columnName}`}
                          label={columns[columnName].text}
                          checked={visibleColumns[columnName] || false}
                          onChange={() => toggleColumn(columnName)}
                        />
                      ))}
                    </Form.Group>
                  </div>
                </ul>
              </div>
            </OverlayTrigger>
          </div>
          {isAddNewBtnRequired && (
            <div className="col-auto">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
              >
                <button id="Add-btn" onClick={handleAddNew}>
                  <i className="fa fa-plus"></i> Add
                </button>
              </OverlayTrigger>
            </div>
          )}
        </div>

        {/* Desktop layout (hidden on mobile) */}
        <div className="d-none d-md-flex justify-content-between">
          <div className="d-flex">
            <div className="me-1">
              <SearchBar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
            {isFilterRequired && (
              <div className="dropdown">
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
                >
                  <button
                    className="dropdown-toggle"
                    type="button"
                    id="excel-btn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-funnel-fill"></i>
                  </button>
                </OverlayTrigger>
                <div>
                  <Dynamic_FilterForm
                    formData={formDatas || []}
                    handleChange={handleChange}
                    handleReset={handleReset}
                    handleGetData={handleGetData}
                    filterFormData={filterFormData}
                  />
                </div>
              </div>
            )}
            <div
              style={{
                display: "flex",
                gap: "16px",
                marginLeft: "8px",
              }}
            >
              {ReadOnlyValues?.map((stat, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#f8f9fa",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    height: "35px",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>{stat.label}: </span>
                  <span>
                    {typeof stat.value === "number" &&
                    stat.label.toLowerCase().includes("amount")
                      ? stat.value.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 2,
                        })
                      : stat.value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
            >
              <div className="me-1">
                <ExportToExcel
                  data={currentData.map((item) => {
                    const visibleItem = {};
                    Object.keys(columns)
                      .filter((columnName) => visibleColumns[columnName])
                      .forEach((columnName) => {
                        const isDateColumn =
                          /\b(date|on Bench|Date|From|To)\b/i.test(
                            columns[columnName].text
                          );
                        visibleItem[columns[columnName].text] = isDateColumn
                          ? formatDate(item[columnName])
                          : item[columnName];
                      });
                    return visibleItem;
                  })}
                  filename={`${ExcelName}.csv`}
                />
              </div>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
            >
              <div className="btn-group me-2" style={{ zIndex: 100 }}>
                <button
                  type="button"
                  className="dropdown-toggle skill-button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  id="excel-btn"
                >
                  <i className="bi bi-list"></i>
                </button>
                <ul className="dropdown-menu p-2">
                  <div
                    className="row"
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                  >
                    <Form.Group>
                      {Object.keys(columns).map((columnName) => (
                        <Form.Check
                          key={columnName}
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          type="checkbox"
                          id={`checkbox-${columnName}`}
                          label={columns[columnName].text}
                          checked={visibleColumns[columnName] || false}
                          onChange={() => toggleColumn(columnName)}
                        />
                      ))}
                    </Form.Group>
                  </div>
                </ul>
              </div>
            </OverlayTrigger>
            {isAddNewBtnRequired && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
              >
                <button id="Add-btn" onClick={handleAddNew}>
                  <i className="fa fa-plus"></i> Add
                </button>
              </OverlayTrigger>
            )}
          </div>
        </div>
      </div>

      <div className=" ">
        <div className="table-responsive  mb-2">
          <Table striped bordered hover rounded>
            <thead id="thcolor" className="text-center">
              <tr>
                {isCheckBoxRequired && (
                  <th style={{ width: "25px" }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAllChecked}
                      onChange={(e) => handleSelectAllChange(e)}
                    />
                  </th>
                )}
                {isSrNoRequired && <th style={{width:"57px"}}>Sr. No.</th>}
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn = /\b(date|on Bench|Date|From|To)\b/i.test(
                    columns[columnName].text
                  );

                  const columnAlignment = columns[columnName].align || "left";
                  const columnWidth = columns[columnName].width;
                  const isButtonColumn = columns[columnName].type === "button";
                  const isModalColumn = columns[columnName].type === "Modal";
                  const isImageColumn = columns[columnName].type === "Image";
                  const isLinkColumn = columns[columnName].type === "Link";
                  const hasIcon = columns[columnName].icon;

                  return (
                    visibleColumns[columnName] && (
                      <th
                        style={{ whiteSpace: "nowrap", width: columnWidth || "auto", minWidth: columnWidth || "auto", maxWidth: columnWidth || "auto" }}
                        key={columnName}
                        onClick={
                          isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon)
                            ? () => handleSort(columnName)
                            : undefined
                        }
                      >
                        {columns[columnName].text}
                        {isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon) && (
                            <span className="ms-1">
                              {sortConfig.key === columnName ? (
                                sortConfig.direction === "ascending" ? (
                                  <i className="bi bi-chevron-up"></i>
                                ) : (
                                  <i className="bi bi-chevron-down"></i>
                                )
                              ) : (
                                <i className="bi bi-chevron-down"></i>
                              )}
                            </span>
                          )}
                      </th>
                    )
                  );
                })}
                {isActionRequired && <th>Action</th>}
              </tr>
            </thead>
            {isRequiredStatus ? (
              isApiStatus === 200 && currentData?.length != 0 ? (
                <tbody>
                  {currentData.map((item, index) => (
                    <tr key={index}>
                      {isCheckBoxRequired && (
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              !!selectedResource.find(
                                (o) => o.EmployeeID === item.EmployeeID
                              )
                            }
                            onChange={(e) =>
                              handleCheckboxChange(e, item.EmployeeID, item)
                            }
                          />
                        </td>
                      )}
                      {isSrNoRequired && (
                        <td className="text-center" style={{width:"57px"}}>
                          {(currentPage - 1) * selectedRecordsPerPage +
                            (index + 1)}
                        </td>
                      )}
                      {Object.keys(columns).map((columnName) => {
                        const isDateColumn =
                          /\b(date|on Bench|Purchase Dt |Waranty Dt |Act. DOJ|Date	|From|To)\b/i.test(
                            columns[columnName].text
                          );

                        const columnAlignment =
                          columns[columnName].align || "left";
                        const columnWidth = columns[columnName].width;

                        const isButtonColumn =
                          columns[columnName].type === "button";
                        const isModalColumn =
                          columns[columnName].type === "Modal";
                        const isImageColumn =
                          columns[columnName].type === "Image";
                        const isLinkColumn =
                          columns[columnName].type === "Link";
                        const isSelectColumn =
                          columns[columnName].type === "Select";
                        const isButtonName = columns[columnName].text;
                        const hasIcon = columns[columnName].icon;

                        return (
                          visibleColumns[columnName] &&
                          (item[columnName] !== null &&
                          item[columnName] !== undefined ? (
                            isImageColumn ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    backgroundColor: "gray",
                                    overflow: "hidden", // This ensures the image is clipped within the circle
                                    cursor: "pointer", // Indicates it's clickable
                                  }}
                                  onClick={() => {
                                    hanldeImageClick(item[columnName]);
                                    // Add your logic here, e.g., open modal, zoom image, etc.
                                  }}
                                >
                                  <img
                                    src={item[columnName]}
                                    alt="User"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </div>
                              </div>
                            ) : (
                              <OverlayTrigger
                                key={columnName}
                                placement="auto"
                                overlay={
                                  <Tooltip id={`tooltip-${columnName}`}>
                                    {isDateColumn
                                      ? formatDate(item[columnName])
                                      : item[columnName]}
                                  </Tooltip>
                                }
                              >
                                <td
                                  className={`text-${
                                    columnAlignment || "center"
                                  } text-truncate`}
                                  style={{
                                    width: columnWidth || undefined,
                                    minWidth: columnWidth || undefined,
                                    maxWidth: columnWidth || "80px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {isButtonColumn ? (
                                    <button
                                      className={`text-${columnAlignment} custom-btn`}
                                      onClick={() =>
                                        handleBtn(columnName, item)
                                      }
                                    >
                                      {isButtonName}
                                    </button>
                                  ) : hasIcon ? (
                                    <div
                                      className="d-flex align-items-center justify-content-center text-center"
                                      onClick={() =>
                                        handleIconClick(columnName, item)
                                      }
                                    >
                                      <span className="me-2">
                                        {icons[columns[columnName].icon]}
                                      </span>
                                      {item[columnName]}
                                    </div>
                                  ) : isDateColumn ? (
                                    formatDate(item[columnName])
                                  ) : isModalColumn ? (
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="text-primary text-decoration-none"
                                      onClick={() =>
                                        handleModalColumn(columnName, item)
                                      }
                                    >
                                      {" "}
                                      {item[columnName]}
                                    </a>
                                  ) : isLinkColumn ? (
                                    <a
                                      style={{
                                        cursor: "pointer",
                                        color: "#27568c !important",
                                      }}
                                      className=" text-black fw-bold text-decoration-none"
                                      onClick={() =>
                                        hanldeLinkColumn(columnName, item)
                                      }
                                      href={item.FilePath}
                                      target="_blank"
                                    >
                                      {" "}
                                      {item[columnName]}
                                    </a>
                                  ) : isSelectColumn ? (
                                    <>
                                      <Select
                                        name={columnName} // Use unique column name
                                        onChange={(selectedOption, action) => {
                                          // Update the value of the selected option for this specific row and column
                                          handleColumnSelect(
                                            selectedOption,
                                            item
                                          );

                                          // Update the state for the current row and column
                                          setDropdownValue((prevState) => ({
                                            ...prevState,
                                            [item.ID]: {
                                              // Use item.id (or any unique identifier for the row)
                                              ...prevState[item.ID],
                                              [columnName]: selectedOption, // Update only for this column of the current row
                                            },
                                          }));
                                        }}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                        value={
                                          dropDownValue[item.ID]?.[
                                            columnName
                                          ] || // Get value for this specific row and column
                                          columns[columnName].option?.find(
                                            (o) => o.value === item[columnName]
                                          ) || { value: null, label: "Select" }
                                        }
                                        options={[
                                          { value: null, label: "Select" },
                                          ...columns[columnName].option,
                                        ]}
                                      />
                                    </>
                                  ) : ["Active", "As Locked"].includes(
                                      columns[columnName].text
                                    ) ? (
                                    <span>
                                      {item[columnName]}
                                      {/* {item[columnName] ? "Yes" : "No"} */}
                                    </span>
                                  ) : (
                                    item[columnName]
                                  )}
                                </td>
                              </OverlayTrigger>
                            )
                          ) : (
                            <td
                              key={columnName}
                              className={`text-${columnAlignment} text-truncate`}
                              style={{
                                maxWidth: columnWidth || "60px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {isButtonColumn ? (
                                <button
                                  className={
                                    item?.ShowStatus == ""
                                      ? "custom-btn"
                                      : "custom-disable-btn"
                                  }
                                  onClick={() => handleBtn(columnName, item)}
                                  disabled={item?.ShowStatus !== ""}
                                >
                                  {isButtonName}
                                </button>
                              ) : hasIcon ? (
                                // <OverlayTrigger
                                //   placement="bottom"
                                //   overlay={
                                //     <Tooltip id="tooltip-bottom">
                                //       {item[columns[columnName].iconText] || "Edit"}
                                //     </Tooltip>
                                //   }
                                // >
                                <div
                                  className="d-flex align-items-center justify-content-center text-center"
                                  onClick={() =>
                                    handleIconClick(columnName, item)
                                  }
                                >
                                  <span className="me-2">
                                    {icons[columns[columnName].icon]}
                                  </span>
                                  {item[columnName]}
                                </div>
                              ) : // </OverlayTrigger>
                              isDateColumn ? (
                                formatDate(item[columnName])
                              ) : item[columnName] ? (
                                item[columnName]
                              ) : null}
                            </td>
                          ))
                        );
                      })}
                      {isActionRequired && (
                        <td>
                          <div className="d-flex justify-content-center text-center">
                            {showIcon1 && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons?.Icon1Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    icons?.Icon1Flag &&
                                    Array.isArray(icons?.Icon1Flag) &&
                                    icons?.Icon1Flag.some(
                                      (flag) =>
                                        item?.[flag] === 0 ||
                                        item?.[flag] === false
                                    )
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (
                                      Array.isArray(icons?.Icon1Flag) &&
                                      icons?.Icon1Flag.length > 0 &&
                                      !icons?.Icon1Flag.some(
                                        (flag) =>
                                          item?.[flag] === 0 ||
                                          item?.[flag] === false
                                      )
                                    ) {
                                      handleIcon1(item);
                                    } else if (!icons?.Icon1Flag) {
                                      // If Icon1Flag is missing, allow clicking
                                      handleIcon1(item);
                                    }
                                  }}
                                >
                                  {icons?.Icon1}
                                </div>
                              </OverlayTrigger>
                            )}

                            {showIcon2 && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon2Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    item[icons.Icon2Flag] === 0 ||
                                    item[icons.Icon2Flag] === false
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (
                                      item[icons.Icon2Flag] !== 0 &&
                                      item[icons.Icon2Flag] !== false
                                    ) {
                                      handleIcon2(item);
                                    }
                                  }}
                                >
                                  {icons.Icon2}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon3 && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon3Text}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    item[icons.Icon3Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (item[icons.Icon3Flag] !== 0)
                                      handleIcon3(item);
                                  }}
                                >
                                  {icons.Icon3}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon4 && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon4Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    item[icons.Icon4Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (item[icons.Icon4Flag] !== 0)
                                      handleIcon4(item);
                                  }}
                                >
                                  {icons.Icon4}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon5 && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon5Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    item[icons.Icon5Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (item[icons.Icon5Flag] !== 0)
                                      handleIcon5(item);
                                  }}
                                >
                                  {icons.Icon5}
                                </div>
                              </OverlayTrigger>
                            )}
                             {showIcon6 && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon6Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    item[icons.Icon6Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (item[icons.Icon6Flag] !== 0)
                                      handleIcon6(item);
                                  }}
                                >
                                  {icons.Icon6}
                                </div>
                              </OverlayTrigger>
                            )}
                             {showIcon7 && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon7Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${
                                    item[icons.Icon7Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (item[icons.Icon7Flag] !== 0)
                                      handleIcon7(item);
                                  }}
                                >
                                  {icons.Icon7}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon8 && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon8Text || "Duplicate"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon8(item)}
                                >
                                  {icons.Icon8}
                                </div>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              ) : isApiStatus === 200 && currentData?.length === 0 ? (
                <tbody>
                  <tr >
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0)+ (isSrNoRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              ) : [400,401,404,409,500].includes(isApiStatus) && currentData?.length === 0 ? (
                <tbody>
                  <tr >
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0)+ (isSrNoRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              ) :isApiStatus === undefined && currentData?.length === 0 ? (
              <tbody>
                  <tr >
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0)+ (isSrNoRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                     <div>
                        <p>
                          <FaSpinner className="spinner" />
                          <br />
                          Loading
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : isApiStatus === undefined ? (
                <tbody>
                  <tr  >
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0) +
                        (isSrNoRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <div>
                        <p>
                          <FaSpinner className="spinner" />
                          <br />
                          Loading
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : (
                // isApiStatus !== 200 && currentData?.length === 0
                <tbody>
                  <tr >
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0)+ (isSrNoRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              )
            ) : currentData?.length != 0 ? (
              <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    {isCheckBoxRequired && (
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={
                            !!selectedResource.find(
                              (o) => o.EmployeeID === item.EmployeeID
                            )
                          }
                          onChange={(e) =>
                            handleCheckboxChange(e, item.EmployeeID, item)
                          }
                        />
                      </td>
                    )}
                    {isSrNoRequired && (
                      <td className="text-center">
                        {(currentPage - 1) * selectedRecordsPerPage +
                          (index + 1)}
                      </td>
                    )}
                    {Object.keys(columns).map((columnName) => {
                      const isDateColumn =
                        /\b(date|on Bench|Act. DOJ| Date|From|To)\b/i.test(
                          columns[columnName].text
                        );

                      const columnAlignment =
                        columns[columnName].align || "left";
                      const columnWidth = columns[columnName].width;

                      const isButtonColumn =
                        columns[columnName].type === "button";
                      const isModalColumn =
                        columns[columnName].type === "Modal";
                      const isImageColumn =
                        columns[columnName].type === "Image";
                      const isLinkColumn = columns[columnName].type === "Link";
                      const isSelectColumn =
                        columns[columnName].type === "Select";
                      const isButtonName = columns[columnName].text;
                      const hasIcon = columns[columnName].icon;

                      return (
                        visibleColumns[columnName] &&
                        (item[columnName] !== null &&
                        item[columnName] !== undefined ? (
                          <OverlayTrigger
                            key={columnName}
                            placement="auto"
                            overlay={
                              <Tooltip id={`tooltip-${columnName}`}>
                                {isDateColumn
                                  ? formatDate(item[columnName])
                                  : item[columnName]}
                              </Tooltip>
                            }
                          >
                            <td
                              className={`text-${
                                columnAlignment || "center"
                              } text-truncate`}
                              style={{
                                maxWidth: columnWidth || "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {isButtonColumn ? (
                                <button
                                  className={`text-${columnAlignment} custom-btn`}
                                  onClick={() => handleBtn(columnName, item)}
                                >
                                  {isButtonName}
                                </button>
                              ) : hasIcon ? (
                                <div
                                  className="d-flex align-items-center justify-content-center text-center"
                                  onClick={() =>
                                    handleIconClick(columnName, item)
                                  }
                                >
                                  <span className="me-2">
                                    {icons[columns[columnName].icon]}
                                  </span>
                                  {item[columnName]}
                                </div>
                              ) : isDateColumn ? (
                                formatDate(item[columnName])
                              ) : isModalColumn ? (
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="text-primary text-decoration-none"
                                  onClick={() =>
                                    handleModalColumn(columnName, item)
                                  }
                                >
                                  {" "}
                                  {item[columnName]}
                                </a>
                              ) : isImageColumn ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                      backgroundColor: "gray",
                                    }}
                                  ></div>
                                </div>
                              ) : isLinkColumn ? (
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="text-black fw-bold text-decoration-none"
                                  onClick={() =>
                                    hanldeLinkColumn(columnName, item)
                                  }
                                  href={item.FilePath}
                                  target="_blank"
                                >
                                  {" "}
                                  {item[columnName]}
                                </a>
                              ) : isSelectColumn ? (
                                <>
                                  <Select
                                    name={columnName} // Use unique column name
                                    onChange={(selectedOption, action) => {
                                      // Update the value of the selected option for this specific row and column
                                      handleColumnSelect(selectedOption, item);

                                      // Update the state for the current row and column
                                      setDropdownValue((prevState) => ({
                                        ...prevState,
                                        [item.ID]: {
                                          // Use item.id (or any unique identifier for the row)
                                          ...prevState[item.ID],
                                          [columnName]: selectedOption, // Update only for this column of the current row
                                        },
                                      }));
                                    }}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    value={
                                      dropDownValue[item.ID]?.[columnName] || // Get value for this specific row and column
                                      columns[columnName].option?.find(
                                        (o) => o.value === item[columnName]
                                      ) || { value: null, label: "Select" }
                                    }
                                    options={[
                                      { value: null, label: "Select" },
                                      ...columns[columnName].option,
                                    ]}
                                  />
                                </>
                              ) : ["Active", "As Locked"].includes(
                                  columns[columnName].text
                                ) ? (
                                <span>
                                  {item[columnName]}
                                  {/* {item[columnName] ? "Yes" : "No"} */}
                                </span>
                              ) : (
                                item[columnName]
                              )}
                            </td>
                          </OverlayTrigger>
                        ) : (
                          <td
                            key={columnName}
                            className={`text-${columnAlignment} text-truncate`}
                            style={{
                              maxWidth: columnWidth || "auto",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {isButtonColumn ? (
                              <button
                                className={`text-${columnAlignment} custom-btn`}
                                onClick={() => handleBtn(columnName, item)}
                              >
                                {isButtonName}
                              </button>
                            ) : hasIcon ? (
                              // <OverlayTrigger
                              //   placement="bottom"
                              //   overlay={
                              //     <Tooltip id="tooltip-bottom">
                              //       {item[columns[columnName].iconText] || "Edit"}
                              //     </Tooltip>
                              //   }
                              // >
                              <div
                                className="d-flex align-items-center justify-content-center text-center"
                                onClick={() =>
                                  handleIconClick(columnName, item)
                                }
                              >
                                <span className="me-2">
                                  {icons[columns[columnName].icon]}
                                </span>
                                {item[columnName]}
                              </div>
                            ) : // </OverlayTrigger>
                            isDateColumn ? (
                              formatDate(item[columnName])
                            ) : item[columnName] ? (
                              item[columnName]
                            ) : null}
                          </td>
                        ))
                      );
                    })}
                    {isActionRequired && (
                      <td>
                        <div className="d-flex justify-content-center text-center">
                          {showIcon1 && (
                            <OverlayTrigger
                              placement="auto"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon1Text || "Edit"}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${
                                  icons?.Icon1Flag &&
                                  Array.isArray(icons.Icon1Flag) &&
                                  icons.Icon1Flag.some(
                                    (flag) =>
                                      item[flag] === 0 || item[flag] === false
                                  )
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (
                                    !icons?.Icon1Flag || // If Icon1Flag is not provided, always allow clicking
                                    !Array.isArray(icons.Icon1Flag) || // If not an array, allow clicking
                                    !icons.Icon1Flag.some(
                                      (flag) =>
                                        item[flag] === 0 || item[flag] === false
                                    )
                                  ) {
                                    handleIcon1(item);
                                  }
                                }}
                              >
                                {icons.Icon1}
                              </div>
                            </OverlayTrigger>
                          )}

                          {showIcon2 && (
                            <OverlayTrigger
                              placement="auto"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon2Text || "Edit"}
                                </Tooltip>
                              }
                            >
                              <div
                                // className='me-2'
                                // onClick={() => handleIcon2(item)}

                                // className={`me-2 ${
                                //   item[icons.Icon2Flag] === 0
                                //     ? "disabled-icon"
                                //     : ""
                                // }`}
                                className={`me-2 ${
                                  item[icons.Icon2Flag] === 0 ||
                                  item[icons.Icon2Flag] === false
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                // onClick={() => {
                                //   if (item[icons.Icon2Flag] !== 0)
                                //     handleIcon2(item);
                                // }}
                                onClick={() => {
                                  if (
                                    item[icons.Icon2Flag] !== 0 ||
                                    item[icons.Icon2Flag] !== false
                                  ) {
                                    handleIcon2(item);
                                  }
                                }}
                              >
                                {icons.Icon2}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon3 && (
                            <OverlayTrigger
                              placement="auto"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon3Text}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${
                                  item[icons.Icon3Flag] === 0
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (item[icons.Icon3Flag] !== 0)
                                    handleIcon3(item);
                                }}
                              >
                                {icons.Icon3}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon4 && (
                            <OverlayTrigger
                              placement="auto"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon4Text || "Add"}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${
                                  item[icons.Icon4Flag] === 0
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (item[icons.Icon4Flag] !== 0)
                                    handleIcon4(item);
                                }}
                              >
                                {icons.Icon4}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon5 && (
                            <OverlayTrigger
                              placement="auto"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon5Text || "Add"}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${
                                  item[icons.Icon5Flag] === 0
                                    ? "disabled-icon"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (item[icons.Icon5Flag] !== 0)
                                    handleIcon5(item);
                                }}
                              >
                                {icons.Icon5}
                              </div>
                            </OverlayTrigger>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr  >
                  <td
                    colSpan={
                      Object.keys(columns).length +
                      (isCheckBoxRequired ? 1 : 0) +
                      (isActionRequired ? 1 : 0) +
                      (isSrNoRequired ? 1 : 0)
                    }
                    className="text-center"
                  >
                    <div>
                      <p>
                        {/* <FaSpinner className="spinner" /> */}
                        {/* <br /> */}
                        No data found..!
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
        {/* {filteredData.length > itemsPerPage && ( */}
    <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-3">
  {/* 1️⃣ Text on the left, per-page dropdown on the right */}
  <div className="d-flex justify-content-between px-2">
    <span style={{ width: "150px" }}>
      Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
      {Math.min(
        currentPage * selectedRecordsPerPage,
        filteredData.length
      )}{" "}
      of {filteredData.length}
    </span>

    <div style={{ width: "80px" }}>
      <select
        value={selectedRecordsPerPage}
        onChange={handleRecordsPerPage}
        className="mx-2 form-select form-select-sm"
      >
        {recordsPerPageOption.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  </div>

  {/* 2️⃣ Pagination centred on small screens, right-aligned ≥ 576 px */}
  <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-100">
    <Pagination
      itemsPerPage={selectedRecordsPerPage}
      totalItems={filteredData.length}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  </div>
</div>
        {/* )} */}
      </div>
    </div>
  );
};

export default CRDynamic_PR_table;
